export default __webpack_public_path__ + "static/media/auth-verify-success-2.254aebb7.png";